import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography, Form, Input } from 'antd';

import BreadcrumbContainer from '../Breadcrumb';
import CustomButton from '../../components/CustomButton';
import INTERNAL_LINKS from '../../enums/InternalLinks';

import './style.scss';

const { TextArea } = Input;
const { Title, Paragraph } = Typography;
const breadcrumbItems = [
  {
    text: 'Categoria por proyecto',
    to: `${INTERNAL_LINKS.PROJECT_CATEGORIES}`,
  },
  {
    text: 'Formulario de Categoría por proyecto',
  },
];

const tailLayout = {
  wrapperCol: { offset: 0, span: 12 },
};

const validateMessages = {
  required: '${label} Es Requerido!',
  types: {
    nombre: '${label} No es un nombre válido!',
    descripcion: '${label} No es una descripción válida!',
  },
};

const ProjectCategoryForm = ({ title, onFinish, initialValues, loading }) => {
  return (
    <>      
      <div className="form-container">
        <Form
          name="nest-messages"
          layout="vertical"
          onFinish={onFinish}
          validateMessages={validateMessages}
          initialValues={initialValues}
          autoComplete="off"
        >
          <Form.Item
            name="nombre"
            label="Categoría"
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value.length <= 100) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Solo puede ingresar 100 caracteres!');
                },
              }),
            ]}
          >
            <Input allowClear />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <div className="box-btn">
              <CustomButton loading={loading} text="Guardar" />
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

ProjectCategoryForm.propTypes = {
  title: PropTypes.string,
  onFinish: PropTypes.func,
  initialValues: PropTypes.object,
  loading: PropTypes.bool,
};

ProjectCategoryForm.defaultProps = {
  title: '',
  onFinish: () => {},
  initialValues: {},
  loading: false,
};

export default ProjectCategoryForm;
